/**
 * React Query mutation options shared by the message-write mutations
 * (`usePutMessagesMutation`, `usePostThreadMutation`). A failed message write is
 * a critical, recoverable error (ADR 065): these options retry any failure up to
 * 3 times with exponential backoff (~1s, 2s, 4s).
 */
export const MESSAGES_WRITE_OPTIONS = {
  retry: (failureCount: number) => failureCount < 3,
  retryDelay: (attempt: number) => Math.min(1000 * 2 ** attempt, 30000),
} as const;
